import { type ComposedForm } from 'lib-node-question-builder';

import { READONLY_CONDITION } from '../../common/utils/utils';
import type { Income1003FormValues } from './Income1003Form';
import { newCpaInformationObject } from './income1003FormListeners';

type CpaInformationFieldArrayProps = {
  form: ComposedForm<Income1003FormValues>;
};

const cpaTextFieldDefinitions = [
  { name: 'cpaFirstName', label: 'First Name' },
  { name: 'cpaMiddleName', label: 'Middle Name' },
  { name: 'cpaLastName', label: 'Last Name' },
  { name: 'cpaCompanyName', label: 'Company Name' },
] as const;

const createCpaTextField = (
  fieldName: (typeof cpaTextFieldDefinitions)[number]['name'],
  label: string,
) => ({
  elementType: 'question' as const,
  type: 'text' as const,
  name: `cpaInformation[{i}].${fieldName}`,
  label,
  hasBottomBorder: false,
  span: 3,
  conditions: {
    isDisabled: READONLY_CONDITION,
  },
});

export default function CpaInformationFieldArray({
  form,
}: Readonly<CpaInformationFieldArrayProps>) {
  return (
    <form.FieldArray
      name="cpaInformation"
      label=""
      enableAdd={{
        when: 'isWriteAccessDisabled',
        isNot: true,
        dataSource: 'screenData',
      }}
      addButtonLabel="Add Additional CPA"
      appendDefaultItem={newCpaInformationObject()}
      template={[
        {
          elementType: 'component',
          type: 'grid',
          name: 'cpaInformationGridRow',
          style: { padding: '0 0.5rem' },
          columns: 13,
          fields: [
            ...cpaTextFieldDefinitions.map(({ name, label }) =>
              createCpaTextField(name, label),
            ),
            {
              elementType: 'component',
              type: 'fieldArrayDeleteButton',
              name: 'deleteCpaInformationButton',
              value: '{i}',
              conditions: {
                isDisabled: READONLY_CONDITION,
              },
            },
          ],
        },
      ]}
    />
  );
}
